/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AcademicYearDataApiDto } from '../model/academic-year-data.model';
// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';
// @ts-ignore
import { JuniorPriceListsApiDto } from '../model/junior-price-lists.model';
// @ts-ignore
import { PriceListOnlineApiDto } from '../model/price-list-online.model';
// @ts-ignore
import { PriceListOnlineWithDisclaimersApiDto } from '../model/price-list-online-with-disclaimers.model';
// @ts-ignore
import { PriceListPublicHolidaysApiDto } from '../model/price-list-public-holidays.model';
// @ts-ignore
import { PriceListPublicHolidaysV2ApiDto } from '../model/price-list-public-holidays-v2.model';
// @ts-ignore
import { PriceListSchoolApiDto } from '../model/price-list-school.model';
// @ts-ignore
import { PriceListTermsApiDto } from '../model/price-list-terms.model';
// @ts-ignore
import { PriceListTermsLanguageApiDto } from '../model/price-list-terms-language.model';
// @ts-ignore
import { PriceListYearsApiDto } from '../model/price-list-years.model';
// @ts-ignore
import { PriceListsFilterApiDto } from '../model/price-lists-filter.model';
// @ts-ignore
import { YoungAdultPriceListDataApiDto } from '../model/young-adult-price-list-data.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { PricelistControllerApiServiceInterface } from './pricelist-controller.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class PricelistControllerApiService extends BaseService implements PricelistControllerApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAyaPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<AcademicYearDataApiDto>;
  public getAyaPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<AcademicYearDataApiDto>>;
  public getAyaPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<AcademicYearDataApiDto>>;
  public getAyaPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getAyaPriceLists.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getAyaPriceLists.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getAyaPriceLists.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/aya`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AcademicYearDataApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getJuniorCampsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<JuniorPriceListsApiDto>;
  public getJuniorCampsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<JuniorPriceListsApiDto>>;
  public getJuniorCampsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<JuniorPriceListsApiDto>>;
  public getJuniorCampsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getJuniorCampsPriceLists.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getJuniorCampsPriceLists.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getJuniorCampsPriceLists.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/junior-camps`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<JuniorPriceListsApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public getOnlinePriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListOnlineApiDto>;
  public getOnlinePriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListOnlineApiDto>>;
  public getOnlinePriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListOnlineApiDto>>;
  public getOnlinePriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getOnlinePriceLists.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getOnlinePriceLists.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getOnlinePriceLists.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/online`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListOnlineApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOnlinePriceListsWithDisclaimers(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListOnlineWithDisclaimersApiDto>;
  public getOnlinePriceListsWithDisclaimers(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListOnlineWithDisclaimersApiDto>>;
  public getOnlinePriceListsWithDisclaimers(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListOnlineWithDisclaimersApiDto>>;
  public getOnlinePriceListsWithDisclaimers(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getOnlinePriceListsWithDisclaimers.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getOnlinePriceListsWithDisclaimers.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getOnlinePriceListsWithDisclaimers.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v2/price-lists/online`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListOnlineWithDisclaimersApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPriceListYears(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListYearsApiDto>;
  public getPriceListYears(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListYearsApiDto>>;
  public getPriceListYears(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListYearsApiDto>>;
  public getPriceListYears(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getPriceListYears.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getPriceListYears.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/years`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListYearsApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public getPriceListsPublicHolidays(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListPublicHolidaysApiDto>;
  public getPriceListsPublicHolidays(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListPublicHolidaysApiDto>>;
  public getPriceListsPublicHolidays(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListPublicHolidaysApiDto>>;
  public getPriceListsPublicHolidays(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getPriceListsPublicHolidays.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getPriceListsPublicHolidays.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getPriceListsPublicHolidays.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/holidays`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListPublicHolidaysApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPriceListsPublicHolidaysV2(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListPublicHolidaysV2ApiDto>;
  public getPriceListsPublicHolidaysV2(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListPublicHolidaysV2ApiDto>>;
  public getPriceListsPublicHolidaysV2(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListPublicHolidaysV2ApiDto>>;
  public getPriceListsPublicHolidaysV2(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getPriceListsPublicHolidaysV2.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getPriceListsPublicHolidaysV2.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getPriceListsPublicHolidaysV2.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v2/price-lists/holidays`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListPublicHolidaysV2ApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPriceListsTermsAndConditions(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<PriceListTermsApiDto>;
  public getPriceListsTermsAndConditions(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<PriceListTermsApiDto>>;
  public getPriceListsTermsAndConditions(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<PriceListTermsApiDto>>;
  public getPriceListsTermsAndConditions(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getPriceListsTermsAndConditions.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getPriceListsTermsAndConditions.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/terms`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PriceListTermsApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param area
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPriceListsTermsAndConditionsLanguages(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    area?: 'EU' | 'ROW' | 'ONLINE',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<PriceListTermsLanguageApiDto>>;
  public getPriceListsTermsAndConditionsLanguages(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    area?: 'EU' | 'ROW' | 'ONLINE',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<PriceListTermsLanguageApiDto>>>;
  public getPriceListsTermsAndConditionsLanguages(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    area?: 'EU' | 'ROW' | 'ONLINE',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<PriceListTermsLanguageApiDto>>>;
  public getPriceListsTermsAndConditionsLanguages(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    area?: 'EU' | 'ROW' | 'ONLINE',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getPriceListsTermsAndConditionsLanguages.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getPriceListsTermsAndConditionsLanguages.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>area, 'area');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/terms/languages`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PriceListTermsLanguageApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSchoolPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<PriceListSchoolApiDto>>;
  public getSchoolPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<PriceListSchoolApiDto>>>;
  public getSchoolPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<PriceListSchoolApiDto>>>;
  public getSchoolPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getSchoolPriceLists.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getSchoolPriceLists.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getSchoolPriceLists.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PriceListSchoolApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getYoungAdultsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<YoungAdultPriceListDataApiDto>;
  public getYoungAdultsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<YoungAdultPriceListDataApiDto>>;
  public getYoungAdultsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<YoungAdultPriceListDataApiDto>>;
  public getYoungAdultsPriceLists(
    filter: PriceListsFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling getYoungAdultsPriceLists.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getYoungAdultsPriceLists.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getYoungAdultsPriceLists.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pricing/v1/price-lists/young-adults`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<YoungAdultPriceListDataApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
